// Shared "sections" shape for both CSV and XLSX exports (see xlsx.ts) — one
// table per section, e.g. "Daily views", "Top pages", "Top blog posts".
export interface ExportSection {
  title: string
  headers: string[]
  rows: (string | number)[][]
}

function escapeCsvField(v: string | number): string {
  const s = String(v)
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

export function toCsv(sections: ExportSection[]): string {
  const lines: string[] = []
  for (const section of sections) {
    lines.push(section.title)
    lines.push(section.headers.map(escapeCsvField).join(','))
    for (const row of section.rows) lines.push(row.map(escapeCsvField).join(','))
    lines.push('')
  }
  return lines.join('\n')
}

function downloadBlob(filename: string, blob: Blob) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export function downloadCsv(filename: string, sections: ExportSection[]) {
  downloadBlob(filename, new Blob([toCsv(sections)], { type: 'text/csv;charset=utf-8' }))
}
